// @flow
import styled from '@emotion/styled';
import { COLORS, FONT_WEIGHTS, SPACING, typography } from '@tablekit/theme';
import RichText from 'components/RichText';
import PersonImage, { SIZES } from 'components/PersonImage';
import type { AuthorType } from 'components/types';
import { getPageContext } from 'components/PageContext';
import { MOBILE_BREAKPOINT } from 'utils/theme';

type PropsType = {
  author?: AuthorType
};

const AuthorText = styled.p`
  margin-bottom: ${SPACING.L4};
  ${typography('L4')};

  @media ${MOBILE_BREAKPOINT} {
    ${typography('L3')};
  }
`;

const AuthorSummary = styled.div`
  border-top: 1px solid ${COLORS.GRAY.L4};
  border-bottom: 1px solid ${COLORS.GRAY.L4};
  margin: ${SPACING.L8} 0;
  padding: ${SPACING.L6} 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media ${MOBILE_BREAKPOINT} {
    align-items: center;
    padding: ${SPACING.L2} 0;
  }
`;

const AuthorSummaryText = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${SPACING.L6};
  @media ${MOBILE_BREAKPOINT} {
    margin-left: ${SPACING.L3};
  }
`;

const AboutAuthorTitle = styled.div`
  font-weight: ${FONT_WEIGHTS.BOLD};
  ${typography('L5')};
  @media ${MOBILE_BREAKPOINT} {
    ${typography('L3')};
    margin-bottom: ${SPACING.L2};
  }
`;

const AboutAuthorText = styled(RichText)`
  ${typography('L4')};
  @media ${MOBILE_BREAKPOINT} {
    ${typography('L1')};
  }
`;

const AuthorFooter = ({ author }: PropsType) => {
  const { blogConfig } = getPageContext();
  const { name, image, about } = author || {
    name: 'Invalid Author Profile Selected',
    image: '',
    about: null
  };
  return (
    <AuthorSummary>
      <PersonImage
        alt={name}
        src={image}
        size={{
          [MOBILE_BREAKPOINT]: SIZES.BLOG_MOBILE,
          default: SIZES.DEFAULT
        }}
      />
      <AuthorSummaryText>
        <AboutAuthorTitle>{blogConfig.about_author_title}</AboutAuthorTitle>
        <AuthorText>{name}</AuthorText>
        {about && <AboutAuthorText richText={about} />}
      </AuthorSummaryText>
    </AuthorSummary>
  );
};

export default AuthorFooter;
